// @flow
import * as jwt from 'jsonwebtoken';

import type { AuthData } from '../models/AuthData';

export function castDataToAuthData(data: any): AuthData {
  const mainData = {
    type: data.token_type,
    expiresIn: data.expires_in,
    accessToken: data.access_token,
    refreshToken: data.refresh_token,
  };

  const result = jwt.decode(data.access_token);

  if (typeof result === 'object' && result != null) {
    return {
      ...mainData,
      authId: parseInt(result.sub, 10),
      scopes: Array.isArray(result.scopes) ? result.scopes : [],
    };
  }

  return {
    ...mainData,
    authId: null,
    scopes: [],
  };
}

export default castDataToAuthData;



// WEBPACK FOOTER //
// ./src/modules/auth/utils/castDataToAuthData.js